import { ROLE_HIERARCHY, roleAtLeast, roleSchema } from '@lms/shared-types'
import type { Role } from '@lms/shared-types'

export type { Role }
export { ROLE_HIERARCHY, roleAtLeast, roleSchema }

const ROLE_LABELS: Record<Role, string> = {
  employee: 'Employee',
  manager: 'Manager',
  hod: 'HOD',
  hr: 'HR',
  director: 'Director',
  exec_director: 'Executive Director',
  admin: 'Admin',
  superadmin: 'Super Admin',
}

export function roleLabel(role: Role): string {
  return ROLE_LABELS[role]
}

/** HR ops = HR plus the system admins (admin / superadmin), but NOT line
 *  directors/exec. These roles run the HR-first-review process, so they always
 *  see the true `pending_hr_review` status (nothing is masked from them) and
 *  they get the HR Doc Review surfaces. Accepts a possibly-undefined role from
 *  the session and returns false for it. */
export function isHrOps(role: Role | string | undefined | null): boolean {
  return role === 'hr' || role === 'admin' || role === 'superadmin'
}
